import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-level",
  "use": "icon-level-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-level\"><defs><style type=\"text/css\"></style></defs><path d=\"M925.482667 260.736l-207.573334 128.128-199.082666-265.941333a8.576 8.576 0 0 0-13.738667 0L306.133333 388.864 98.432 260.736a8.618667 8.618667 0 0 0-13.013333 8.448l81.493333 620.373333c1.194667 8.448 8.448 14.976 17.066667 14.976h656.170666c8.533333 0 15.872-6.4 16.938667-14.933333l81.493333-620.373333a8.704 8.704 0 0 0-13.098666-8.490667z m-134.4 570.709333H232.832L175.445333 393.984l149.12 92.032L512 235.52l187.434667 250.453333 149.12-92.032-57.472 437.461334z\" p-id=\"4310\" /><path d=\"M512 509.184a120.32 120.32 0 0 0 0 240.64 120.32 120.32 0 0 0 0-240.64z m0 171.946667a51.498667 51.498667 0 0 1-51.413333-51.626667c0-28.416 23.04-51.626667 51.413333-51.626667s51.413333 23.082667 51.413333 51.626667c0 28.416-23.04 51.626667-51.413333 51.626667z\" p-id=\"4311\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/level.svg
// module id = JM/o
// module chunks = 100